(function () {
  'use strict';

  var STORAGE_KEY = 'gpv:collection-rail-collapsed';
  var COLLAPSED_CLASS = 'gpv-rail-collapsed';

  function isCollapsed() {
    return document.documentElement.classList.contains(COLLAPSED_CLASS);
  }

  function syncButtons() {
    var collapsed = isCollapsed();
    var buttons = document.querySelectorAll('[data-rail-toggle]');

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }
  }

  function setCollapsed(collapsed) {
    document.documentElement.classList.toggle(COLLAPSED_CLASS, collapsed);

    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
    } catch (error) {}

    syncButtons();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-rail-toggle]') : null;

    if (!button) {
      return;
    }

    event.preventDefault();
    setCollapsed(!isCollapsed());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }

  document.addEventListener('shopify:section:load', syncButtons);
})();
